module.exports = __webpack_public_path__ + "img/bkg.cde458dd.png";